import {Colors} from "@bounce/shared/ui";

interface IconCallCenterProps {
  color?: string;
  size?: number;
}

export const IconCallCenter = ({size = 24, color = Colors.primary._300}: IconCallCenterProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 15.4124V9.74573C20 5.87973 16.4183 2.74573 12 2.74573C7.58172 2.74573 4 5.87973 4 9.74573V13.4124M6.22222 16.7457C4.99492 16.7457 4 15.8752 4 14.8013V12.2457C4 11.1718 4.99492 10.3013 6.22222 10.3013C7.44952 10.3013 7.55556 11.1718 7.55556 12.2457V14.8013C7.55556 15.8752 7.44952 16.7457 6.22222 16.7457ZM17.7778 16.7457C16.5505 16.7457 16.4444 15.8752 16.4444 14.8013V12.2457C16.4444 11.1718 16.5505 10.3013 17.7778 10.3013C19.0051 10.3013 20 11.1718 20 12.2457V13.8013C20 14.8752 19.0051 16.7457 17.7778 16.7457Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20 15.2457V18C20 19.6568 18.6569 21 17 21H13" stroke={color} strokeWidth="2" />
      <ellipse cx="13" cy="21" rx="2" ry="1.75" fill={color} />
    </svg>
  );
};
